export const storeLocationAPIs = {
  add: {
    url: 'storeLocation',
    method: 'post',
    isAuthEnabled: true,
  },
  delete: {
    url: 'storeLocation',
    method: 'delete',
    isAuthEnabled: true,
  },
  get: {
    url: 'storeLocation',
    method: 'get',
    isAuthEnabled: true,
  },
  update: {
    url: 'storeLocation',
    method: 'patch',
    isAuthEnabled: true,
  },
};
